export default "__VITE_ASSET__CPHmbwxc__"